export const ACCOUNT_MANAGER_GROUP_REPORT_ID = 'account-manager-group';
